module.exports = __webpack_public_path__ + "static/media/header_bg.6ad0fc08.png";